'use strict';

/**
 * Vault only stores objects, so apiCreds which are strings get stored as {"augustStringValue": <value>}
 * @type {string}
 */
module.exports.VAULT_API_CRED_STRING_FIELD_NAME = 'augustStringValue';

/**
 * The name of the header used to communicate between august-vault-api and august-vault-ui
 * @type {string}
 */
module.exports.VAULT_API_SESSION_HEADER_NAME = 'august-vault-session';

/**
 * Path in vault for the apiCreds
 * @type {string}
 */
module.exports.VAULT_APICREDS_PATH_PREFIX = 'kv2/data/apicreds/';

/**
 * Prefix for app policies (i.e., policyName: 'app-policy-rest-api')
 * @type {string}
 */
module.exports.VAULT_APP_POLICY_PREFIX = 'app-policy-';

/**
 * Prefix for app roles (i.e., policyName: 'app-role-rest-api')
 * @type {string}
 */
module.exports.VAULT_APP_ROLE_PREFIX = 'app-role-';

/**
 * The path prefix for configuration values (db/cache/messaging)
 * @type {string}
 */
module.exports.VAULT_CONNECTIONS_PREFIX = 'connectionStrings/data/';

/**
 * The name of the key which contains a connection's value
 *
 * @type {string}
 */
module.exports.VAULT_CONNECTIONS_VALUE_KEY = 'value';

/**
 * The name of the key which contains a connection's path information
 *
 * @type {string}
 */
module.exports.VAULT_CONNECTIONS_PATH_KEY = 'path';

/**
 * Needed to list values in key/value 2
 * @type {string}
 */
module.exports.VAULT_APICREDS_METADATA_PREFIX = 'kv2/metadata/apicreds/';

/**
 * The path prefix for app-role-*
 * @type {string}
 */
module.exports.VAULT_APP_ROLE_ROLE_PATH_PREFIX = 'auth/approle/role/';

/**
 * Needed to list values in key/value 2
 * @type {string}
 */
module.exports.VAULT_CONNECTION_STRINGS_METADATA_PREFIX = 'connectionStrings/metadata/';
